<app-spremiste-zaglavlje
  [parentArchiveName]="parentArchiveName"
  [parentObjectName]="parentObjectName"
  [parentObjectAdress]="parentObjectAdress"
  [parentObjectArea]="parentObjectArea"
  [parentProstorijaName]="parentProstorijaName"
  [parentProstorijaArea]="parentProstorijaArea"
  [parentSpremisnaJedinicaName]="parentSpremisnaJedinicaName"
  [lokacijaName]="lokacijaName"
/>

<ntap-prime-common-itemview #itemView></ntap-prime-common-itemview>
